import type { CardConfigType, CategoryConfigType } from '../type'

const dfsDetectMatchedPath = (card: CardConfigType, pathname: string) => {
  if (card.url === pathname) {
    return true
  }

  const childCards = card.cards || []
  for (let i = 0; i < childCards.length; i++) {
    if (dfsDetectMatchedPath(childCards[i], pathname)) {
      return true
    }
  }

  return false
}

const getDefaultExpanded = ({
  config,
  pathname,
}: {
  config: CardConfigType | CategoryConfigType
  pathname: string
}): boolean => {
  if (pathname === '/control') return false // early break
  if ('url' in config && config.url === pathname) {
    return true
  }
  const defaultExpanded = !!config.cards?.some((card: CardConfigType) => {
    return dfsDetectMatchedPath(card, pathname)
  })
  return defaultExpanded
}

export default getDefaultExpanded
